import { GCStatusType } from './GCStatusType';

export const GCStatusTypeOptions = [
    {
        id: GCStatusType.Invited,
        name: 'Invited',
        shortName: 'Invited',
    },
    {
        id: GCStatusType.NeedsProject,
        name: 'Needs Project',
        shortName: 'No Proj.',
    },
    {
        id: GCStatusType.Pending,
        name: 'Pending GC',
        shortName: 'Pend.',
    },
    {
        id: GCStatusType.Activated,
        name: 'Activated',
        shortName: 'Active',
    },
];
